import React, {useEffect, useState} from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { DefaultHeader } from './DefaultHeader'
import { SideHeader } from './SideHeader'
interface Props {
    style?: React.CSSProperties,
    color?: string
}

export const Header: React.FC<Props> = (props) => {
    const [active, setActive] = useState(false)
    const matches = useMediaQuery('(max-width:1094px)')
    
    const listenScrollEvent = () => {
        if (window.scrollY > 30)
          setActive(true)
        else 
          setActive(false)
      }
    
    useEffect(()=>{
        window.addEventListener('scroll', listenScrollEvent)
        return function cleanupListener() {
          window.removeEventListener('scroll', listenScrollEvent)
        }
    }, [])


    if(matches)
      return <SideHeader color={props.color} active={active}/>
    else
      return <DefaultHeader color={props.color} active={active}/>
}






